import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';

type MuiSelect = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiSelect'];
  defaultProps?: ComponentsProps['MuiSelect'];
  variants?: ComponentsVariants['MuiSelect'];
};

export const MuiSelect: MuiSelect = {
  styleOverrides: {
    filled: {
      height: '100%',
      boxSizing: 'border-box',
    },
  },
};
